import { buildUriQueryOrFragmentArbitrary } from './_internals/builders/UriQueryOrFragmentArbitraryBuilder.js';
export function webFragments() {
    return buildUriQueryOrFragmentArbitrary();
}
